"use client";

import DetailActualGallery from "./gallery";
import DetailActualText from "./text";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const DetailActualContent = () => {
  return (
    <Container className={S.wrapper}>
      <DetailActualText />
      <DetailActualGallery />
    </Container>
  );
};

export default DetailActualContent;
